import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UploadDropZoneComponent} from './upload-drop-zone/upload-drop-zone.component';
import {SortedKeyValuePipe} from './sorted-key-value.pipe';
import {ValuesPipe} from './values.pipe';
import {BtnLoadingDirective} from './btn-loading.directive';
import {SumPipe} from './sum.pipe';
import {MaterialPipe} from './material.pipe';
import {CategoryPipe} from './category.pipe';
import {PrimaryIdPipe} from './primary-id.pipe';
import {NzUploadModule} from 'ng-zorro-antd/upload';
import {NzIconModule} from 'ng-zorro-antd/icon';

@NgModule({
  declarations: [UploadDropZoneComponent, SortedKeyValuePipe, ValuesPipe,
    BtnLoadingDirective, SumPipe, MaterialPipe, CategoryPipe, PrimaryIdPipe],
  imports: [
    CommonModule,
    NzUploadModule,
    NzIconModule
  ],
  exports: [UploadDropZoneComponent, SortedKeyValuePipe, ValuesPipe,
    BtnLoadingDirective, SumPipe, MaterialPipe, CategoryPipe, PrimaryIdPipe]
})
export class SharedModule {
}
